import { Component, OnInit } from "@angular/core";
import { CONSTANTS } from "app/constants";
import { BanDto, PlayerShortDto, PlayerTrainingResultDto, SquadNumberDto } from "app/models";
import { TeamCardDto } from "app/models/dtos/team-card.dto";
import { PlayerService, SecurityService, TeamService } from "app/services";

@Component({
    selector: 'roster-page',
    templateUrl: './roster.page.html',
    styleUrls: ['./roster.page.scss'],
})
export class RosterPage implements OnInit {
    
    squad: PlayerShortDto[];
    currentTeamId: number;
    trainingReport: PlayerTrainingResultDto[];
    graduates: number[];
    squadNumbers: SquadNumberDto[];
    teamCardDto: TeamCardDto;
    bans: BanDto[];
    nationalBanDictionary: number[] = [];
    euroCupBanDictionary: number[] = [];

    constructor(private playerService: PlayerService,
        private securityService: SecurityService,
        private teamService: TeamService) {

    }
    
    ngOnInit(): void {
        this.securityService.getCachedAuths() 
            .subscribe(authResult => {
                this.currentTeamId = authResult.primaryTeamId;

                this.loadData();
        });
    }

    private loadData() {
        this.teamService.getTeamCard(this.currentTeamId)
            .subscribe(result => {
                this.teamCardDto = result;
            });

        this.playerService.findFoRoster(this.currentTeamId)
            .subscribe(result => {
                this.squad = result;
            });

        this.playerService.getTainingReports(this.currentTeamId)
            .subscribe(result => {
                this.trainingReport = result;
            });

        this.playerService.getLatestGraduates(this.currentTeamId)
                .subscribe(result=> {
                    this.graduates = result;
                });

        this.teamService.getSquadNumbers(this.currentTeamId)
                .subscribe(result => {
                    this.squadNumbers = result;
                });

        this.playerService.getBansForTeam(this.currentTeamId).subscribe(result => {
            this.bans = result;

            this.nationalBanDictionary = [];
            this.euroCupBanDictionary = [];

            this.bans.forEach(item => {
                if (item.type == CONSTANTS.banTypes.national) {
                    this.nationalBanDictionary[item.playerId] = 1;
                }
                if (item.type == CONSTANTS.banTypes.euroCup) {
                    this.euroCupBanDictionary[item.playerId] = 1;
                }
            });
        });
    }

        

}